import { isDesktopSafari } from './clientPlatform';

export function canPlayNativeHls(video) {
    if (!video || typeof video.canPlayType !== 'function') {
        return false;
    }
    return video.canPlayType('application/vnd.apple.mpegurl') !== '';
}

/**
 * Safari desktop non riproduce HLS via hls.js/MSE in modo affidabile.
 * Chrome e Firefox restano su hls.js. Il player del telefono non usa questa funzione.
 */
export function shouldPreferNativeHls(video) {
    return isDesktopSafari() && canPlayNativeHls(video);
}
